import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import { BoardMembershipRoles } from '../constants/Enums';
import BoardActions from '../components/BoardActions';

const mapStateToProps = state => {
  const allUsers = selectors.selectUsersForCurrentOrganization(state);
  const isCurrentUserManager = selectors.selectIsCurrentUserManagerForCurrentProject(state);
  const memberships = selectors.selectMembershipsForCurrentBoard(state);
  const labels = selectors.selectLabelsForCurrentBoard(state);
  const filterUsers = selectors.selectFilterUsersForCurrentBoard(state);
  const filterLabels = selectors.selectFilterLabelsForCurrentBoard(state);
  const filterText = selectors.selectFilterTextForCurrentBoard(state);
  const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);
  const currentUser = selectors.selectCurrentUser(state);

  const isCurrentUserEditor =
    !!currentUserMembership && currentUserMembership.role === BoardMembershipRoles.EDITOR;

  const onlyOwnCards =
    !!currentUserMembership &&
    currentUserMembership.role === BoardMembershipRoles.VIEWER &&
    !!currentUserMembership.onlyOwnCards;

  return {
    memberships,
    labels,
    filterUsers,
    filterLabels,
    filterText,
    allUsers,
    canEdit: isCurrentUserEditor,
    canEditMemberships: isCurrentUserManager,
    onlyOwnCards,
    currentUserId: currentUser ? currentUser.id : null,
    organizationId: currentUser
      ? typeof currentUser.organizationId === 'object'
        ? currentUser.organizationId.id
        : currentUser.organizationId
      : null,
  };
};

const mapDispatchToProps = dispatch => {
  const actions = bindActionCreators(
    {
      onMembershipCreate: entryActions.createMembershipInCurrentBoard,
      onMembershipInvite: entryActions.inviteMemberToCurrentBoard,
      onMembershipUpdate: entryActions.updateBoardMembership,
      onMembershipDelete: entryActions.deleteBoardMembership,
      onUserToFilterAdd: entryActions.addUserToFilterInCurrentBoard,
      onUserFromFilterRemove: entryActions.removeUserFromFilterInCurrentBoard,
      onLabelToFilterAdd: entryActions.addLabelToFilterInCurrentBoard,
      onLabelFromFilterRemove: entryActions.removeLabelFromFilterInCurrentBoard,
      onLabelCreate: entryActions.createLabelInCurrentBoard,
      onLabelUpdate: entryActions.updateLabel,
      onLabelMove: entryActions.moveLabel,
      onLabelDelete: entryActions.deleteLabel,
      onTextFilterUpdate: entryActions.filterText,
      syncOrganizationFromClerk: entryActions.syncOrganizationFromClerk,
    },
    dispatch
  );

  return {
    ...actions,
    onMembershipSync: organizationId => actions.syncOrganizationFromClerk(organizationId),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onMembershipSync: () => dispatchProps.onMembershipSync(stateProps.organizationId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(BoardActions);
